export function IconTile({ icon, tone = "accent", size = "md" }) {
  return (
    <div className={`icon-tile icon-tile-${tone} icon-tile-${size}`}>
      {icon}
    </div>
  );
}
